<script>
    import { fetchGet } from "../utils/utilsFetch.js";

    import { getLocaleResource } from "../utils/locales.js";

    import {
        dateFormatterSimple,
        dateTimeFormatter,
    } from "../utils/utilsTabulator.js";

    import { isLoading, cartCount, locale, scrollToSku } from "../stores.js";

    import { addToCart, getCartCount } from "../utils/utils.js";

    export let sku;

    let quantity;

    let product, description;

    let properties = [];

    async function getProduct(sku) {
        $isLoading = true;

        $scrollToSku = sku;

        product = null;

        product = await fetchGet(`/api/products?sku=${sku}`);

        quantity = product.cartQuantity;

        if (product.properties) {
            properties = product.properties
                .split(";")
                .filter((item) => item != "")
                .map((property) => property.split(":"));
        }

        $isLoading = false;
    }

    $: getProduct(sku);

    $: isMiminumQuantity = quantity >= product?.packaging;
</script>

<div class="container">
    {#if product}
        <div class="sync">
            {dateTimeFormatter(product.syncDateTime)}
        </div>

        <div class="pic">
            <img src={product.img} />
        </div>

        <div class="info">
            <div class="title">
                {product.productName}
            </div>

            <div class="info-item">
                <div class="label">{getLocaleResource($locale, "sku")}:</div>
                {product.sku}
            </div>

            <!-- <div class="info-item">
                <div class="label">Цена со ДДВ:</div>
                {product.priceWithVat} KM
            </div> -->

            <div class="info-item">
                <div class="label">{getLocaleResource($locale, "price")}:</div>
                {product.priceWithoutVat} KM
            </div>

            <div class="info-item">
                <div class="label">
                    {getLocaleResource($locale, "discount")}:
                </div>
                {product.totalDiscount}%
            </div>

            <div class="info-item">
                <div class="label">
                    {getLocaleResource($locale, "finalPrice")}:
                </div>
                {product.finalPriceWithoutVat} KM
            </div>

            <!-- 
            <div class="info-item">
                <div class="label">Ваша цена со ДДВ:</div>
                {product.finalPriceWithVat} KM
            </div>


            <div class="info-item">
                <div class="label">
                    {getLocaleResource($locale, "packaging")}:
                </div>
                {product.packaging}
            </div>
            -->

            <div class="info-item">
                <div class="label">
                    {getLocaleResource($locale, "barcode")}:
                </div>
                {product.barcodes}
            </div>

            <div class="info-item">
                <div class="label">
                    {getLocaleResource($locale, "packaging")}:
                </div>
                {product.packaging}
            </div>

            <div class="info-item">
                <div class="label">{getLocaleResource($locale, "stock")}:</div>
                <span>
                    {product.stockHidden?.split(".")[0]}
                </span>
            </div>

            {#if product.arrivalDate}
                <div class="info-item">
                    <div class="label">
                        {getLocaleResource($locale, "arrival")}:
                    </div>
                    <span>
                        {dateFormatterSimple(product.arrivalDate)}
                    </span>
                </div>
            {/if}

            <div class="info-item">
                <div class="label">{getLocaleResource($locale, "order")}:</div>
                <input
                    style="width: 100px; margin-right: 20px; {product.stockHidden ==
                    0
                        ? `
                        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='20px' width='120px'><text x='0' y='15' font-size='14' font-family='Sans,Arial' fill='black' fill-opacity='0.2'>${getLocaleResource(
                            locale,
                            'reservation'
                        )}</text></svg>") !important; 
                        background-repeat: no-repeat !important;
                        background-position: 10px 50% !important;
                    `
                        : ''}"
                    bind:value={quantity}
                    on:blur={async (e) => {
                        addToCart(sku, quantity, product.packaging);
                        await getCartCount();
                    }}
                    on:keyup={async (e) => {
                        if (e.key == "Enter") {
                            e.target.blur();
                        }
                    }}
                />
            </div>

            {#if quantity && !isMiminumQuantity}
                <span style="color: red; font-size: 18px; font-weight: bold;">
                    {`${getLocaleResource(
                        locale,
                        "minimumQuantityIs"
                    )} ${product.packaging}`}
                </span>
            {/if}
        </div>

        <div class="properties">
            {#each properties as property}
                <div class="property">
                    <div class="left">{property[0]}:</div>
                    <div class="right">{property[1]}</div>
                </div>
            {/each}
        </div>
    {/if}
</div>

<style>
    .container {
        padding: 10px;
        height: calc(100vh - 50px);

        display: grid;
        grid-template-columns: 3fr 2fr 2fr;
        grid-template-rows: 1fr;
        gap: 50px;
    }

    .pic {
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    img {
        object-fit: contain;
        max-width: 100%;
        max-height: calc(100vh - 100px);
        width: auto;
        height: auto;
    }

    .title {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .info {
        display: flex;
        flex-direction: column;
        height: 100%;
        gap: 20px;
    }

    .info-item {
        display: flex;
        align-items: center;
    }

    .label {
        width: 180px;
        margin-right: 10px;
        font-weight: bold;
    }

    .red {
        color: red;
        font-weight: bold;
    }

    .properties {
        margin-top: 20px;
    }

    .property {
        display: flex;
        margin-bottom: 10px;
    }

    .left {
        width: 150px;
        font-weight: bold;
    }

    .sync {
        position: absolute;
        bottom: 10px;
        right: 10px;
        opacity: 0.3;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            grid-template-columns: 1fr;
            grid-template-rows: 1fr 1fr 1fr;
        }

        img {
            max-height: 200px;
        }

        .info {
            padding-left: 0px;
        }
    }
</style>
